import React from 'react';
import { Card, CardMedia, CardContent, Typography, Box } from '@mui/material';

const CardComponent = ({ title, description, image, link }) => {
  return (
    <Card
      sx={{
        maxWidth: 1200,
        margin: '1rem auto',
        padding: '1rem',
        borderRadius: 3,
        background: 'rgba(15,23,42,0.6)',
        border: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '0 12px 40px rgba(0,0,0,0.35)',
        '@media (max-width: 768px)': {
          maxWidth: '100%',
          margin: '0.5rem auto',
          padding: '0.5rem',
        },
      }}
    >
      <CardMedia
       component="img"
       height="540"
       image={image}
       alt={title}
       sx={{
         borderRadius: 2,
         '@media (max-width: 768px)': {
           height: 'auto',
           width: '100%',
          },
        }}
      />
      <CardContent
        sx={{
          textAlign: 'center',
          '@media (max-width: 768px)': {
            padding: '0.5rem',
          },
        }}
      >
        <Typography
          variant="h5"
          component={link ? 'a' : 'span'}
          href={link || undefined}
          target={link ? '_blank' : undefined}
          rel={link ? 'noopener noreferrer' : undefined}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            textAlign: 'center',
            marginBottom: '0.5rem',
            textDecoration: 'none',
            color: '#E6EEF6',
            fontFamily: 'Sora, sans-serif',
            fontWeight: 700,
            '&:hover': {
              color: '#06B6D4',
            },
            '@media (max-width: 768px)': {
              fontSize: '1.2rem',
            },
          }}
        >
          {title}
          {link && (
            <Box
              component="span"
              sx={{
                display: 'inline-block',
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: '#06B6D4',
              }}
            />
          )}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            lineHeight: 1.5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            color: '#C7D2FE',
            fontFamily: 'Source Sans 3, sans-serif',
            '@media (max-width: 768px)': {
              fontSize: '0.9rem',
            },
          }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardComponent;
